import { LTButton, LTText } from '@lambdatestincprivate/lt-components';
import styles from './states.module.css';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var format = function format(n) {
  return typeof n === 'number' ? "".concat(Math.round(n / (1024 * 1024)), " MB") : 'unknown size';
};

/** One exhaustive code → remediation map. No message sniffing. */
function adviceFor(error) {
  var _error$detail2, _error$detail3, _error$detail$found, _error$detail4;
  var code = error.code;
  switch (code) {
    case 'fetch-failed':
      return {
        heading: "Couldn't fetch the pack",
        body: 'The pack URL did not respond or blocked the request (CORS). The ' + 'host must allow this origin and expose Range headers ' + '(Access-Control-Expose-Headers: Content-Range, Accept-Ranges, ' + 'Content-Length). kane-cli’s local server does this automatically.'
      };
    case 'http-error':
      {
        var _error$detail;
        var status = (_error$detail = error.detail) === null || _error$detail === void 0 ? void 0 : _error$detail.status;
        if (status === 403) {
          return {
            heading: 'Pack link expired',
            body: 'The URL returned 403 — a signed link has likely expired. Reload ' + 'the page that embedded this viewer to mint a fresh link.'
          };
        }
        if (status === 404) {
          return {
            heading: 'Pack not found',
            body: 'The URL returned 404. Check the link or re-share it.'
          };
        }
        return {
          heading: "The pack host answered HTTP ".concat(String(status !== null && status !== void 0 ? status : '?')),
          body: 'The pack could not be fetched. Check the URL and try again.'
        };
      }
    case 'size-unavailable':
      return {
        heading: "Can't size the pack",
        body: 'The host hides Content-Range from cross-origin readers and HEAD ' + 'returned no Content-Length. Add Content-Range to the storage ' + "account's CORS ExposedHeaders (the setting everyone forgets)."
      };
    case 'pack-too-large':
      return {
        heading: 'Pack too large to stream from this host',
        body: "This host ignores Range requests, and the pack (".concat(format((_error$detail2 = error.detail) === null || _error$detail2 === void 0 ? void 0 : _error$detail2.size), ") exceeds the ").concat(format((_error$detail3 = error.detail) === null || _error$detail3 === void 0 ? void 0 : _error$detail3.limit), " whole-download limit. Host it on storage with Range support ") + '(S3, Azure Blob, kane-cli) or open the file locally instead.'
      };
    case 'not-a-zip':
      return {
        heading: 'Not an evidence pack',
        body: "This file isn't a sealed .evidence archive (no zip directory " + 'found). A live, unsealed pack directory must be finalized first.'
      };
    case 'not-a-pack':
      return {
        heading: 'Not an evidence pack',
        body: 'The archive has no readable top-level run.yaml with evidence/' + 'run_id — it may be truncated or produced by an incompatible tool.'
      };
    case 'unsupported-version':
      return {
        heading: 'Unsupported evidence version',
        body: "This viewer reads evidence 0.x; the pack declares \"".concat(String((_error$detail$found = (_error$detail4 = error.detail) === null || _error$detail4 === void 0 ? void 0 : _error$detail4.found) !== null && _error$detail$found !== void 0 ? _error$detail$found : '?'), "\". A newer viewer is required.")
      };
    case 'unsupported-compression':
    case 'corrupt-entry':
    case 'entry-too-large':
      return {
        heading: "Couldn't read the pack",
        body: error.message
      };
    case 'aborted':
      return {
        heading: 'Loading cancelled',
        body: ''
      };
    default:
      {
        var exhaustive = code;
        return {
          heading: 'Something went wrong',
          body: String(exhaustive)
        };
      }
  }
}
export function ErrorScreen(_ref) {
  var error = _ref.error,
    onReset = _ref.onReset;
  var advice = adviceFor(error);
  return /*#__PURE__*/_jsx("div", {
    className: styles.wrap,
    role: "alert",
    children: /*#__PURE__*/_jsxs("div", {
      className: styles.card,
      children: [/*#__PURE__*/_jsx("span", {
        className: styles.alertIcon,
        "aria-hidden": "true",
        children: "!"
      }), /*#__PURE__*/_jsx(LTText, {
        as: "h1",
        text: advice.heading,
        color: "var(--ev-fg)",
        className: styles.heading,
        style: {
          fontSize: '20px',
          lineHeight: '28px',
          fontWeight: 600
        }
      }), advice.body && /*#__PURE__*/_jsx(LTText, {
        as: "p",
        text: advice.body,
        variant: LTText.TextVariant.SUBHEADER_REGULAR,
        color: "var(--ev-fg-muted)",
        className: styles.body
      }), /*#__PURE__*/_jsx(LTText, {
        as: "p",
        text: error.message,
        variant: LTText.TextVariant.SMALL_REGULAR,
        color: "var(--ev-fg-subtle)",
        className: styles.detail
      }), /*#__PURE__*/_jsx(LTButton, {
        label: "Try a local file instead",
        variant: LTButton.Variant.DEFAULT,
        size: LTButton.Size.MEDIUM,
        onClick: onReset,
        style: {
          marginTop: '8px'
        }
      })]
    })
  });
}